var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMask(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "12px",
    viewBox: "0 0 10 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icMask") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.86805634,6.83851049 C3.44952113,6.83851049 2.30428169,5.6986951 2.31729577,4.31278322 L2.31729577,2.70667972 C2.31729577,1.30781538 3.46253521,0.168 4.86805634,0.168 C6.27357746,0.168 7.4188169,1.30781538 7.4188169,2.70667972 L7.4188169,4.29983077 C7.4188169,5.6986951 6.27357746,6.83851049 4.86805634,6.83851049 Z M9.436,11.1516755 C9.436,11.3589147 9.2668169,11.5272965 9.07160563,11.5272965 L0.612450704,11.5272965 C0.404225352,11.5272965 0.235042254,11.3589147 0.235042254,11.1516755 L0.235042254,10.2838615 C0.235042254,9.55852448 0.59943662,8.89794965 1.22411268,8.50937622 L3.00704225,7.40841818 C3.34540845,7.18822657 3.73583099,7.08460699 4.12625352,7.08460699 L5.49273239,7.08460699 C5.88315493,7.08460699 6.26056338,7.18822657 6.59892958,7.39546573 L8.43391549,8.50937622 C9.04557746,8.8849972 9.436,9.57147692 9.436,10.296814 L9.436,11.1516755 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Version3-Final",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Event-Details-Popup",
    transform: "translate(-441.000000, -543.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(420.000000, 109.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(21.000000, 431.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/General/Users-Copy-3",
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "userProfile",
    transform: "translate(0.240000, 0.120000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/black"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icMask",
    fill: "#333333",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMask);
export default __webpack_public_path__ + "static/media/icMask.20c6dc969b0a30847b1414c4fe1a5379.svg";
export { ForwardRef as ReactComponent };